/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ($) {
  $ = jQuery;

  var threshold = window.innerHeight / 2;
  $(window)
    .on("scroll resize", function () {
      if ($(window).scrollTop() > threshold) {
        $(".back-to-top").show();
      } else {
        $(".back-to-top").hide();
      }
    })
    .trigger("scroll");

  function viewport() {
    var e = window,
      a = "inner";
    if (!("innerWidth" in window)) {
      a = "client";
      e = document.documentElement || document.body;
    }
    return {
      width: e[a + "Width"],
      height: e[a + "Height"],
    };
  }

  $(document).on("click", ".sqs-simple-like a.anc-like", function () {
    var post_id = jQuery(this).attr("data-id");
    var data = {
      ajaxaction: "true",
      postid: post_id,
      action: "LikePostCount",
    };
    jQuery.post(SCOPESDFOBJ.ajaxurl, data, function (response) {
      jQuery(".count-like").html(response);
    });
  });

  $.post("/api/scopesdf/account/", function (html) {
    $(`#account`).html(html);
  });

  $(document).on("click", ".social-buttons", function () {
    jQuery(this).parents("ul").next(".social-share-buttons").toggle();
  });

  $(".common-slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    adaptiveHeight: true,
    arrows: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 }},
      {
        breakpoint: 501,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
    ],
  });

  $(".four-slider").slick({
    dots: false,
    adaptiveHeight: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    arrows: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 }},
      {
        breakpoint: 501,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
    ],
  });

  $(".tow-slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    arrows: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 }},
      {
        breakpoint: 501,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  });

  if ($(".header-section").length > 0) {
    $(".header-section .main-nav-container .logo-section").after('<button type="button" class="ebiz-toggle"><span></span></button>');
    $(".header-section").before('<span class="body-bg-overlay"></span>');

    $(".header-section__logo").append('<button type="button" class="ebiz-toggle"><span></span></button>');
  }

  if ($(".main-menu li.menu-item-has-children").length > 0) {
    $(".main-menu li.menu-item-has-children > a").append('<span class="mobile-toggle"></span>');
  }

  if ($(".header-section__main-menu li.menu-item-has-children").length > 0) {
    $(".header-section__main-menu li.menu-item-has-children > a").append('<span class="mobile-toggle"></span>');
  }

  $(".ebiz-toggle").click(function () {
    $(this).toggleClass("ebiz-menuopen");
    $("body").toggleClass("mobile-nav-open");
    $(".mainmenu").slideToggle(200);
    $(".body-bg-overlay").toggleClass("display");
  });

  $(".body-bg-overlay").click(function () {
    $(this).removeClass("display");
    $(".ebiz-toggle").removeClass("ebiz-menuopen");
    $("body").removeClass("mobile-nav-open");
  });

  (function () {
    $(".main-menu .menu-item-has-children > a").click(function () {
      $(this).parent().siblings(".menu-item-has-children").find("a").removeClass("ebiz-subopen");
      $(this).parent().siblings(".menu-item-has-children").find(".sub-menu").slideUp(250);
      $(this).next(".sub-menu").slideToggle(250);
      $(this).next(".sub-menu").children(".menu-item-has-children").find(".sub-menu").slideUp(250);
      $(this).next(".sub-menu").children(".menu-item-has-children").find("a").removeClass("ebiz-subopen");
      $(this).toggleClass("ebiz-subopen");
      if ($(window).width() < 992) {
        return false;
      }
    });

    $(".header-section__main-menu .menu-item-has-children > a").click(function () {
      $(this).parent().siblings(".menu-item-has-children").find("a").removeClass("ebiz-subopen");
      $(this).parent().siblings(".menu-item-has-children").find("ul").eq(0).slideUp(250);
      $(this).next("ul").slideToggle(250);
      $(this).next("ul").children(".menu-item-has-children").find(".sub-menu").slideUp(250);
      $(this).next("ul").children(".menu-item-has-children").find("a").removeClass("ebiz-subopen");
      $(this).toggleClass("ebiz-subopen");
      if ($(window).width() < 992) {
        return false;
      }
    });

    $(".header-section .search--toggle").on("click", function () {
      $(".header-section__inner .header-section__search-container").toggleClass("show");
    });
  });
})();

function equalheight(container) {
  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0,
    currentDiv;

  jQuery(container).each(function () {
    $el = jQuery(this);
    jQuery($el).height("auto");
    topPosition = $el.position().top;
    if (currentRowStart != topPosition) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}

jQuery(window).resize(function () {
  equalheight(".equalheight");
  //   equalheight('.community-section .col-sm-2');
  equalheight(".column-four-section .row .col-sm-3");
});

jQuery(window).on("load", function () {
  equalheight(".equalheight");
  //   equalheight('.community-section .col-sm-2');
  equalheight(".column-four-section .row  .col-sm-3");
});

// For Sticky Header
(function ($) {
  var $header = null,
    $headerWrapper = null,
    bottomHeader = 0,
    lastScrollTop = 0;

  $(document).ready(function () {
    $header = $(".header-section");
    $headerWrapper = $(".header-section__wrapper");
    bottomHeader = $headerWrapper.offset().top + $headerWrapper.outerHeight();
    $header.css("padding-top", $headerWrapper.outerHeight() + "px");
  });

  $(window).on("scroll", function () {
    var scrollYWindow = this.scrollY;
    if (scrollYWindow > bottomHeader + 50) {
      if ($headerWrapper && !$headerWrapper.hasClass("fixed")) $headerWrapper.addClass("fixed");
    } else {
      if ($headerWrapper && $headerWrapper.hasClass("fixed")) $headerWrapper.removeClass("fixed");
    }

    if ($headerWrapper && $headerWrapper.hasClass("fixed")) {
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if ($headerWrapper) {
        if (st > lastScrollTop) {
          //downscroll
          $headerWrapper.addClass("header-hidden");
        } else {
          // upscroll
          $headerWrapper.removeClass("header-hidden");
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      }
    }
  });

  // For Scroll-To-Top
  $(document).ready(function () {
    $("#btn_scrolltotop").on("click", function () {
      $("html,body").animate(
        {
          scrollTop: 0,
        },
        500
      );
    });
  });

  // Home
  if ($(".hero-banner__slider").length) {
    $(".hero-banner__slider").slick({
      infinite: true,
      fade: true,
      arrows: false,
      speed: 500,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: 5000,
      lazyLoad: "ondemand",
    });
  }

  if ($(".featured-lessons__item").length) {
    $(".featured-lessons__list").slick({
      infinite: true,
      arrows: true,
      dots: true,
      speed: 500,
      adaptiveHeight: true,
      lazyLoad: "ondemand",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }

  if ($(".hero-banner__latestlist").length && $(window).outerWidth() < 768) {
    $(".hero-banner__latestlist").slick({
      infinite: true,
    });
  }

  if ($(".recBlogpost-mobileonly__list").length && $(window).outerWidth() < 992) {
    $(".recBlogpost-mobileonly__list").slick({
      infinite: true,
      adaptiveHeight: true,
      lazyLoad: "ondemand",
    });
  }

  if ($(".latests-items__itemcopy").length) {
    equalheight(".latests-items__itemcopyinner");
  }
})(window.jQuery);
